module.exports = __webpack_public_path__ + "static/media/nonparticipatoryobservation.bcfdf70c.pdf";